export type VoidFn = () => void;

export const noop: VoidFn = () => void 0;
